import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyBfsPUNl2PUsREaKcTBIjbuSRc7VF7KN7s",
  authDomain: "finomo88.firebaseapp.com",
  projectId: "finomo88",
  storageBucket: "finomo88.firebasestorage.app",
  messagingSenderId: "1088068205851",
  appId: "1:1088068205851:web:c487ee6c7739f9388367be"
};

export const firebaseApp = initializeApp(firebaseConfig);
